'use client';

import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import classes from './LanguageSelector.module.scss';
import Cookies from 'js-cookie';
import { Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { i18n } from '@/i18n-config';
import { Locale } from '@/src/types/Header';
import { proxifyImageUrl } from '@/src/helpers/proxifyImageUrl';

export const LanguageSelector = () => {
  const [opened, { toggle }] = useDisclosure(false);
  const pathname = usePathname();
  const Router = useRouter();
  const locale = pathname.split('/')[1] as Locale;

  const redirectToPathname = (locale: 'fr' | 'en') => {
    Cookies.set('NEXT_LOCALE', locale);

    if (!pathname) {
      return '/';
    }

    const segments = pathname.split('/');
    segments[1] = locale;
    Router.push(segments.join('/'));
  };

  const supportedLanguage = {
    fr: {
      label: 'français',
      img: proxifyImageUrl("https://ik.imagekit.io/3txq1tb44/articles/DALL_E%202025-01-02%2001.15.52%20-%20A%20square%20image%20of%20the%20French%20flag%20designed%20with%20a%20satin-like%20draped%20texture.%20The%20flag's%20colors%20(muted%20blue,%20white,%20and%20red)%20flow%20softly%20with%20elegant%20f.webp?updatedAt=1746473330268"),
    },
    en: {
      label: 'english',
      img: proxifyImageUrl("https://ik.imagekit.io/3txq1tb44/articles/DALL_E%202025-01-02%2001.16.40%20-%20A%20square%20image%20of%20the%20British%20flag%20(Union%20Jack)%20designed%20with%20a%20satin-like%20draped%20texture.%20The%20flag's%20colors%20(muted%20red,%20white,%20and%20blue)%20flow%20softly%20.webp?updatedAt=1746473330257"),
    },
  };

  return (
    <Menu>
      <Menu.Target>
        <Image
          onClick={toggle}
          src={supportedLanguage[locale].img}
          alt={`${locale}`}
          height={40}
          width={40}
          className={classes.langToogle}
        />
      </Menu.Target>
      <Menu.Dropdown style={{ backgroundColor: 'black' }}>
        {i18n.locales.map((locale) => {
          return (
            <Menu.Item key={locale} onClick={() => redirectToPathname(locale)}>
              <span className={classes.link}>
                <Image
                  src={supportedLanguage[locale].img}
                  alt={`${locale}`}
                  height={15}
                  width={20}
                  className={classes.flag}
                />
                {supportedLanguage[locale].label}
              </span>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
